module.exports = __webpack_public_path__ + "static/media/paso3_datos cedula_sms.278a630c.svg";